<template>
  <aside
    class="ca-pesquisa-mais-pesquisados gap-size-3"
    :aria-labelledby="title && !loading ? 'mais-pesquisados-titulo' : undefined"
  >
    <template v-if="loading">
      <div
        class="ca-pesquisa-mais-pesquisados__skeleton-titulo rounded-xs"
        aria-hidden="true"
      />
      <div class="ca-pesquisa-mais-pesquisados__skeleton-lista">
        <div
          v-for="n in 6"
          :key="n"
          class="ca-pesquisa-mais-pesquisados__skeleton-link"
          aria-hidden="true"
        />
      </div>
    </template>
    <template v-else>
      <h2
        v-if="title"
        id="mais-pesquisados-titulo"
        class="ca-pesquisa-mais-pesquisados__titulo caption-action px-size-0 py-size-3"
      >
        {{ title }}
      </h2>
      <ul class="ca-pesquisa-mais-pesquisados__lista">
        <li v-for="(item, idx) in items" :key="idx">
          <a
            :href="item.url"
            class="ca-pesquisa-mais-pesquisados__link caption-action px-size-0 py-size-3 rounded-xs"
          >
            {{ item.title }}
          </a>
        </li>
      </ul>
    </template>
  </aside>
</template>

<script setup>
defineProps({
  title: { type: String, default: "" },
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
</script>

<style scoped lang="scss">
.ca-pesquisa-mais-pesquisados {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  &__skeleton-titulo {
    height: 24px;
    width: 150px;
    border-radius: 8px;
    margin: var(--size-3) 0;
    background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 37%, #e8e8e8 63%);
    background-size: 400% 100%;
    animation: shimmer 1.5s infinite;
  }

  &__skeleton-lista {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  &__skeleton-link {
    height: 40px;
    width: 100%;
    border-radius: 8px;
    background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 37%, #e8e8e8 63%);
    background-size: 400% 100%;
    animation: shimmer 1.5s infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  &__titulo {
    color: var(--ca-color-text-body);
    text-transform: uppercase;
    margin: 0;
  }

  &__lista {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__link {
    display: flex;
    align-items: center;
    min-height: 48px;
    color: var(--ca-color-theme-primary);
    text-decoration: none;
    width: 100%;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      text-decoration: underline;
    }

    &:active {
      text-decoration: underline;
    }

    @media (max-width: 1023.98px) {
      padding: var(--size-3) var(--size-4);
      margin-left: calc(var(--size-4) * -1);

      &:hover {
        text-decoration: none;
        background: var(--ca-color-hover-pressed-container-high-hover);
      }

      &:active {
        text-decoration: none;
        background: var(--ca-color-hover-pressed-inverted-hover-light);
      }
    }

    &[aria-disabled="true"],
    &:disabled {
      opacity: 0.5;
      pointer-events: none;
      cursor: default;
    }

    &:focus-visible {
      outline: 1px solid var(--ca-color-feedback-info);
      outline-offset: 2px;
      border-radius: 10px;
    }
  }
}
</style>
